module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('transition-group', {
    staticClass: "contenedor-transition",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, [_c('div', {
    key: "select-box",
    staticClass: "select-box"
  }, _vm._l((_vm.locales), function(o) {
    return _c('div', {
      staticClass: "option bd-color-empresa",
      class: {
        'bg-empresa': o.codigo === _vm.local.codigo
      },
      on: {
        "click": function($event) {
          _vm.seleccionar(o)
        }
      }
    }, [_c('span', {
      staticClass: "descripcion"
    }, [_vm._v(_vm._s(o.descripcion))])])
  })), (_vm.local && _vm.local.codigo) ? _c('div', {
    key: "description-box",
    staticClass: "description-box message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('div', [_c('strong', [_vm._v("RUC")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(": " + _vm._s(_vm.empresa.ruc))])]), _c('div', [_c('strong', [_vm._v("Razon social")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(": " + _vm._s(_vm.empresa.razonSocial))])]), _c('div', [_c('strong', [_vm._v("Dirección del local")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(": " + _vm._s(_vm.local.direccion))])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("1. Seleccione el local")]), _c('p', [_c('span', [_vm._v("Por favor seleccione el local en el que se encuentra y desea hacer la reclamación")])]), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fe1430c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Box-1-seleccionar-local.vue
// module id = 84
// module chunks = 0